const PROJECT_PATH_PREFIX = "/p/";

/** Only an exact single segment counts as an id — "/p/<id>/extra" must return null, never a truncated/wrong id. */
export function projectIdFromLocation(pathname: string = window.location.pathname): string | null {
  const segments = pathname.split("/").filter((s) => s.length > 0);
  if (segments.length !== 2 || segments[0] !== "p") return null;
  return segments[1];
}

export function projectPath(id: string): string {
  return PROJECT_PATH_PREFIX + id;
}

/** Must preserve whatever `?search`/`#hash` is already on `currentHref` — only the pathname gets overwritten, never dropping an existing query string. */
export function projectUrl(id: string | null, currentHref: string = window.location.href): string {
  const url = new URL(currentHref);
  url.pathname = id === null ? "/" : projectPath(id);
  return url.toString();
}
